"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckedSmallIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.CheckedSmallIcon = (0, react_1.forwardRef)(function CheckedSmallIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "14", height: "12", viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M5.47136 9.33301L11.8857 1.2673C12.2709 0.782916 12.992 0.741926 13.4296 1.17955C13.8022 1.5521 13.8359 2.14487 13.508 2.55729L7.00516 10.7372C6.21466 11.7316 4.70949 11.7467 3.89925 10.7683L0.93939 7.19435C0.595964 6.77967 0.624469 6.17177 1.00519 5.79105C1.43738 5.35887 2.14682 5.38904 2.54075 5.85636L5.47136 9.33301Z", fill: "currentColor" })));
});
